/**
 * SignalDot — 신호등 점. 공종 진행 신호 전용(D-08 §6.15 `primitive.signal.*`, D-07 §1.2 신호등 예외).
 * 표준 ui-core SignalDot(.signal-dot)을 그대로 쓰고, 셸 호출부의 소문자 색 이름만 맞춰 준다.
 * 신호등 외 상태 표시(배지·알림)에는 쓰지 않는다. 점 단독으로 의미를 전달하지 않도록 호출부가 숫자·글자를 곁들인다.
 */
import { SignalDot as CoreSignalDot, type SignalDotColor } from '@indipia/ui-core';

export type SignalColor = 'green' | 'yellow' | 'red' | 'blue' | 'white';

export interface SignalDotProps {
  color: SignalColor;
  /** 지름(px). 기본 10. */
  size?: number;
  className?: string;
}

export function SignalDot({ color, size, className }: SignalDotProps) {
  return <CoreSignalDot color={color.toUpperCase() as SignalDotColor} size={size} className={className} />;
}
